// src/modules/app-views/ticketEvents/pages/Document/components/CardHeaderEventIcons.jsx
import DocumentInfoIcons from 'components/JarvislyComponents/DocumentInfoIcons';

const CardHeaderEventIcons = ({ data }) => {
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 12 }}>
      <DocumentInfoIcons data={data} size={18} />
    </div>
  );
};

export default CardHeaderEventIcons;
